<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="scss">
:root {
  --white: #fff;
  --green: #4caf50;
  --primary-disabled: #79c3ff;
  --primary: #2196f3; // #0095cf; //
  --primary-darker: #1a87e0;
  --red: #e9361f;
  --red-disabled: #e97b6c;
  --red-darker: #ad2c04;
  --light-blue: #e3f2fd;
}

* {
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

html,
body {
  padding: 0;
  margin: 0;
  user-select: none;
  max-width: 500px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue